/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { Modal, Card, Table, message, Form, Spin, Checkbox } from "antd";
import { Row, Col, Space } from "antd";
import { Input, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import { columns } from "./model";
// import ItemService from "../../service/ItemService";
import OptionService from "../../../../service/ERP/Options.service";
import { TagItemTypes } from "../../../badge-and-tag/ERP/";

const CheckboxGroup = Checkbox.Group;

/* ประเภทสินค้าที่ผูกกับลูกค้าได้ — PG ขึ้นก่อน FG */
const TYPE_OPTIONS = [
  { value: "PG", label: "Packing Goods" },
  { value: "FG", label: "Finished Goods" },
];

const opService = OptionService();
export default function ModalCusProduct({ show, close, values, selected }) {
  const [form] = Form.useForm();
  /** handle state */
  const [itemsData, setItemsData] = useState([]);
  const [itemsDataWrap, setItemsDataWrap] = useState([]);

  const [itemsList, setItemsList] = useState(selected || []);
  const [itemsRowKeySelect, setItemsRowKeySelect] = useState([]);
  const [loading, setLoading] = useState(true);
  const inputRef = useRef(null);

  /** ตัวกรองประเภทสินค้า — ค่าเริ่มต้นติ๊กทั้งหมด */
  const [checkedList, setCheckedList] = useState(TYPE_OPTIONS.map((o) => o.value));
  const checkAll = checkedList.length === TYPE_OPTIONS.length;
  const indeterminate =
    checkedList.length > 0 && checkedList.length < TYPE_OPTIONS.length;

  const onCheckAllChange = (e) => {
    const all = e.target.checked ? TYPE_OPTIONS.map((o) => o.value) : [];
    setCheckedList(all);
    applyFilter(null, all);
  };

  /** handle logic component */
  const handleClose = () => {
    close(false);
  };

  /** กรองด้วยคำค้น + ประเภทสินค้าพร้อมกัน */
  const applyFilter = (value, types) => {
    const keyword = (value ?? inputRef.current?.input?.value ?? "").toLowerCase();
    const typeList = types ?? checkedList;

    const f = itemsData.filter((d) => {
      const matchType = typeList.includes(d?.item_type || "PG");
      if (!matchType) return false;
      if (!keyword) return true;
      return (
        d.pg_code?.toLowerCase().includes(keyword) ||
        d.code?.toLowerCase().includes(keyword) ||
        d.pg_name?.toLowerCase().includes(keyword)
      );
    });

    setItemsDataWrap(f);
  };

  const handleSearch = (value) => applyFilter(value, null);

  const onChangeTypes = (list) => {
    setCheckedList([...list]);
    applyFilter(null, list);
  };

  const handleSelectItems = (record) => {
    const newData = {
      ...record,
      qty: 1,
      percent: 0,
      totalpercent: 0,
    };
    // console.log(newData);

    setItemsList([...itemsList, newData]);
  };

  const handleCheckDuplicate = (itemCode) =>
    !!selected.find((item) => item?.pg_code === itemCode);

  const handleConfirm = () => {
    // console.log(selected);
    const choosed = selected.map((m) => m.pg_code);
    const itemsChoose = itemsData
      .filter(
        (f) =>
          itemsRowKeySelect.includes(f.pg_code) && !choosed.includes(f.pg_code)
      )
      .map((m, i) => ({
        item_type: m.item_type || "PG",
        pg_code: m.pg_code,
        pg_name: m.pg_name,
        pg_stname_cus: m.pg_stname_cus,
        pg_ivname: m.pg_ivname,
        price:0,
      }));

    // console.log(itemsChoose, choosed);

    values([...selected, ...itemsChoose]);

    setItemsList([]);
    close(false);
  };

  /** Config Conponent */

  const itemSelection = {
    selectedRowKeys: itemsRowKeySelect,
    type: "checkbox",
    fixed: true,
    // hideSelectAll: false,

    onChange: (selectedRowKeys, selectedRows) => {
      setItemsRowKeySelect([
        ...new Set([...selectedRowKeys, ...itemsRowKeySelect]),
      ]);
      setItemsList(selectedRows);
      setItemsRowKeySelect(selectedRowKeys);
    },
    getCheckboxProps: (record) => {
      return {
        disabled: handleCheckDuplicate(record.pg_code),
        name: record.pg_code,
      };
    },
    onSelect: (record, selected, selectedRows, nativeEvent) => {
      //console.log(record, selected, selectedRows, nativeEvent);
      if (selected) {
        setItemsRowKeySelect([
          ...new Set([...itemsRowKeySelect, record.pg_code]),
        ]);
      } else {
        const ind = itemsRowKeySelect.findIndex((d) => d === record.pg_code);
        const tval = [...itemsRowKeySelect];
        tval.splice(ind, 1);
        setItemsRowKeySelect([...tval]);
        // console.log(ind, itemsRowKeySelect);
      }
    },
  };

  /** End Config Component */

  /** setting initial component */
  const column = columns({ handleSelectItems, handleCheckDuplicate });

  useEffect(() => {
    const onload = () => {
      setLoading(true);
      opService
        .optionsPG({ p: "cus" })
        .then((res) => {
          let { status, data } = res;
          if (status === 200) {
            setItemsData(data.data);
            setItemsDataWrap(data.data);

            const keySeleted = selected.map((m) => m.pg_code);

            setItemsRowKeySelect([...keySeleted]);
            // console.log(selected);
          }
        })
        .catch((err) => {
          message.error("Request error!");
        })
        .finally(() =>
          setTimeout(() => {
            setLoading(false);
          }, 400)
        );
    };

    if (!!show) {
      onload();
      // console.log("modal-select-cusproduct");
    }
  }, [selected, show]);

  /** setting child component */
  const ButtonModal = (
    <Space direction="horizontal" size="middle">
      <Button onClick={() => handleClose()}>ปิด</Button>
      <Button type="primary" onClick={() => handleConfirm()}>
        ยืนยันการเลือกสินค้า
      </Button>
    </Space>
  );
  /** */
  return (
    <>
      <Modal
        open={show}
        title="เลือกสินค้า"
        onCancel={() => handleClose()}
        footer={ButtonModal}
        maskClosable={false}
        style={{ top: 20 }}
        width={1200}
        className="customer-product-modal-cusproduct"
      >
        <Spin spinning={loading}>
          <Space
            direction="vertical"
            size="middle"
            style={{ display: "flex", position: "relative" }}
          >
            <Card style={{ backgroundColor: "#f0f0f0" }}>
              <Form form={form} layout="vertical" autoComplete="off">
                <Row
                  gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                  className="m-0"
                >
                  <Col span={24}>
                    <Form.Item label="ค้นหา" className="!mb-2">
                      <Input
                        ref={inputRef}
                        suffix={<SearchOutlined />}
                        onChange={(e) => {
                          handleSearch(e.target.value);
                        }}
                        placeholder="ค้นหาชื่อ หรือ รหัสสินค้า"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row
                  gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                  className="m-0"
                >
                  <Col span={24}>
                    <Checkbox
                      indeterminate={indeterminate}
                      onChange={onCheckAllChange}
                      checked={checkAll}
                    >
                      <TagItemTypes data={"Check All"} />
                    </Checkbox>
                    <CheckboxGroup
                      value={checkedList}
                      onChange={onChangeTypes}
                      options={TYPE_OPTIONS.map((o) => ({
                        value: o.value,
                        label: <TagItemTypes data={o.label} />,
                      }))}
                    />
                  </Col>
                </Row>
              </Form>
            </Card>
            <Card>
              <Table
                bordered
                dataSource={itemsDataWrap}
                columns={column}
                rowSelection={itemSelection}
                rowKey="pg_code"
                pagination={{
                  total: itemsDataWrap.length,
                  showTotal: (_, range) =>
                    `${range[0]}-${range[1]} of ${itemsData.length} items`,
                  defaultPageSize: 10,
                  pageSizeOptions: [10, 25, 35, 50, 100],
                }}
                scroll={{ x: "max-content" }}
                size="small"
              />
            </Card>
          </Space>
        </Spin>
      </Modal>
    </>
  );
}
